import {
  inventoryItemIdFormat,
  locationIdFormat,
} from "@redotech/redo-inventory-id";
import { productIdFormat } from "@redotech/redo-product-id";
import { storageLocationIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";

export const ProductBinAtLocationSchema = z.object({
  productId: productIdFormat.schema,
  storageLocationId: storageLocationIdFormat.schema,
  binName: z.string(),
  quantity: z.number().int(),
  binType: z.string().nullish(),
  isSellable: z.boolean().nullish(),
  /** Set on lot rows (`includeLots`); identifies the lot for adjustments. */
  inventoryItemId: inventoryItemIdFormat.schema.nullish(),
  lotNumber: z.string().nullish(),
  expirationDate: z.string().nullish(),
});
export type ProductBinAtLocation = z.infer<typeof ProductBinAtLocationSchema>;

export const listProductBinsAtLocation = {
  name: "listProductBinsAtLocation" as const,
  input: z.object({
    productIds: z.array(productIdFormat.schema),
    locationId: locationIdFormat.schema,
    includeLots: z.boolean().optional(),
    /** With `includeLots`, also return zero-quantity rows in bins that physically hold stock. */
    includeEmptyBins: z.boolean().optional(),
  }),
  output: z.object({ bins: z.array(ProductBinAtLocationSchema) }),
};
